var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar ml-3"},[_c('div',{staticClass:"progress-bar__fill",style:({ width: (_vm.percentage + "%"), backgroundColor: _vm.activeColour })})])}
var staticRenderFns = []

export { render, staticRenderFns }